const setBrightness = function (level, fn) {

  const init = {
    method: 'GET'
  };

  fetch(`http://localhost:3001/${level}`, init)
    .catch(function (err) {
      console.log('parsing failed', err);
    });

}

export {
  setBrightness
};



// WEBPACK FOOTER //
// ./src/requests/setBrightness.js